/* eslint 'no-self-assign': "off", 'no-unused-vars':"off" */
import React, {useState,useEffect, useCallback, useRef} from "react";
import { useFetchHubParamsData, useGetLocalizationLabel,useDownloadCSRCertificate, useTestConnectionLink,useAddSecureConnectNetworkPort } from "../useAPIMethods";
import { IconButton, Table, TableBody, TableCell, TableHead, TableRow, Button } from "@material-ui/core";
import FormComponents, {FormErrorSectionDiv, MiniStyledInput, MultiTagWrapper, StyledWrapper, UploadButton, UploadCertiButton, NumStyledInput, StyledInput}from "../FormComponents";
import { TableCellClass, TableRowProps, isEmpty,fileInputFields, initialState } from "../constants";
import {  Header } from "semantic-ui-react";
import { BsFillXOctagonFill, BsQuestionCircleFill } from "react-icons/bs";
import {EditNodeButtonContainer, NoMaxWidthTooltip,EditTableContainer, ModelBodyDiv, HeaderTitle, FooterButtons, EditActions, FileUploadSpinner,  HubParamModal, EditNodeButton, WarningModal, ErrorModal,  GenerateCSRModal, TestConnectionModal, SpinnerContainer } from "../styled";
import { MdClose } from "react-icons/md";
import Spinner from "components/common/LegacySpinner";
import APIutil from "api/APIutils";
import * as url from "api/url";
import { GetExternalHubURILink } from 'action/secureconnectAction';
import { useDispatch, useSelector } from "react-redux";

const EditNodeDetails = ({history, NodeType, props, Name, OnCancel, networkList, getNetworkList, EndPoint, apiData, isEdit, issuerCertData, operCertData}) => {
    const [state, setState] = useState(initialState);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [cancelClicked, setCancelClicked] = useState(false);
    const [csrErrorModel, setCsrErrorModel] = useState(false);
    const [csrSuccessmodel, setCsrSuccessModel] =  useState(false);
    const [IsEnabled, setIsEnabled] = useState(true);    
    const [isLinkModeChange, setIsLinkModeChange] = useState(null);
    const [showHubValidationModal, setShowHubValidationModal] = useState(false);
    const [showModeChangeValidationModal, setShowModeChangeValidationModal] = useState(false);
    const [loading, setIsLoading] = useState(false);
    const [isTestConnection,setIsTestConnection] = useState({status: false, primaryHubURLStatus: false});
    const [testConSuccessModal, setTestConSuccessModal] = useState(false);
    const [testConErrorModal, setTestConErrorModal] = useState(false);
    const [validTestConURL, setValidTestConURL] = useState(false);
    const [apiError, setapiError] = useState('');
    const { data,  submitForm, setAPIHookData, UpdateCertificateStates,
    fileUploadError, fileUploading, getCertificateDetails, refetch,  
    hubIssuCertName , hubOperationCertName, issuerCertValidity, OperationalCertValidity, IssuerCertExpireDt, OperationalCertExpireDt, UpdateExistingCertificateStates} = useFetchHubParamsData();
    const { getLabel, getFormErrorLabel } = useGetLocalizationLabel();
    const {  downloadCSRCertificate } = useDownloadCSRCertificate(history);
    const [formError, setFormError] = useState({});
    const rootFileRef = useRef(null);
    const OpFileRef = useRef(null);
    const externalHubUri = useSelector(state => state.HubManagementRootReducer.GetExternalHubUri);
    const dispatch = useDispatch();
    const { getTestConnectionLink } = useTestConnectionLink();

    const {
        error = "",
        disabled = false,
        type = "",
        affixLabel = "",
        onKeyDown,
    } = [props];

    const tlsVersion = state["tlsVersion"];
    const minValue = tlsVersion.min;
    const maxValue = tlsVersion.max;
  
    const NetworkName = isEdit && apiData.networkName ? apiData.networkName : Name;
    const connectionTimeout = state["reconnectTime"];

    var linkNodeOptions = getLabel("CreateNode").split(',').slice(0,2).map(el => ({"value" : Number(el), "label": getLabel("CreateNode." + el)}));
   
   
    const formData ={ 
        "NetworkID": state["networkID"],
        "NetworkName": NetworkName,
        "EndPointUrl": state["hubMode"] !== 0 ? state["hubURL"] : state["primaryHubURI"],
        "IsNodeConnected": false,
        "NetworkNumber":0,
        "Mode": state["hubMode"],
        "HubPort": data.portNumber,
        "UUID": isEdit && apiData.uuid ? apiData.uuid : "",
        "VMAC": isEdit && apiData.vmac ? apiData.vmac : "",
        "PrimaryHubURL": (state["hubMode"] !== 0 && state["primaryHubURI"] && state["primaryHubURI"] === state["hubURL"].replace(state["hubURL"].split(":")[1],"//localhost")) ? state["primaryHubURI"].substring(0, state["primaryHubURI"].lastIndexOf("/")) : state["primaryHubURI"], //"wss://10.28.253.166:4443/hub",
        "FailOverHubURL": (state["hubMode"] !== 0 && state["failoverHubURI"] && state["failoverHubURI"] === state["hubURL"].replace(state["hubURL"].split(":")[1],"//localhost")) ? state["failoverHubURI"].substring(0, state["failoverHubURI"].lastIndexOf("/")) : state["failoverHubURI"],
        "TlsVersion": [minValue, maxValue],
        "ConnectionTimeOut": Number(connectionTimeout),
        "RootCertificateSubjectName": hubIssuCertName,
        "RootCertificateValidity": issuerCertValidity,
        "OperationalCertificateSubjectName": hubOperationCertName,
        "OperationalCertificateValidity": OperationalCertValidity,
        "IsEnabled": IsEnabled,
        "IsEnableHub": isLinkModeChange,
        "IsTestConnection": isTestConnection.status,
        "IsPrimaryURLTestConnection": isTestConnection.primaryHubURLStatus,
    };  
  
    useEffect(() => {
        if(isEdit && apiData){
            setState(prevState => ({
                ...prevState,
                "hubMode": Number(apiData.mode),
                "networkID": apiData.networkID,
                "reconnectTime": Number(apiData.connectionTimeOut),
                "primaryHubURI": (apiData.mode !== 0 && apiData.primaryHubURL &&  apiData.endPointUrl === (apiData.primaryHubURL.replace(apiData.primaryHubURL.split(":")[1], apiData.endPointUrl.split(":")[1]) + '/' + apiData.networkName)) ? apiData.primaryHubURL + '/' + apiData.networkName : apiData.primaryHubURL,
                "failoverHubURI": (apiData.mode !== 0 && apiData.failOverHubURL && apiData.endPointUrl === (apiData.failOverHubURL.replace(apiData.failOverHubURL.split(":")[1], apiData.endPointUrl.split(":")[1]) + '/' + apiData.networkName)) ? apiData.failOverHubURL + '/' + apiData.networkName : apiData.failOverHubURL,
                "tlsVersion": apiData.tlsVersion ? { "min": apiData.tlsVersion[0], "max": apiData.tlsVersion[1] ? apiData.tlsVersion[1] : apiData.tlsVersion[0] ? apiData.tlsVersion[0] : "Tls12" } : { "min": "Tls12", "max": "Tls13" },
                "useHubAs": (apiData.mode !== 0)? (apiData.endPointUrl === apiData.primaryHubURL.replace(apiData.primaryHubURL.split(":")[1], apiData.endPointUrl.split(":")[1]) + '/' + apiData.networkName) ? "Primary Hub" : (apiData.endPointUrl === apiData.failOverHubURL.replace(apiData.failOverHubURL.split(":")[1], apiData.endPointUrl.split(":")[1]) + '/' + apiData.networkName) ? "Failover Hub" : "" : "",
            }));
            setIsEnabled(apiData.isEnabled);
            UpdateCertificateStates(apiData.rootCertificateSubjectName, apiData.rootCertificateValidity, issuerCertData, apiData.operationalCertificateSubjectName, apiData.operationalCertificateValidity, operCertData );
        }

    },[apiData])

    useEffect(() => { 
        if (state.issuerCertFile && state.issuerCertFile.length) {
            setState(prevState => ({...prevState, selectedFileKey: "issuerCertFile", isModelOpen: true}));
        }
        if (rootFileRef && rootFileRef.current && !state.issuerCertFile) {
            rootFileRef.current.value = "";
        }       
    }, [state.issuerCertFile]);

    useEffect(() => {  
        if (state.operationalCertificateRequest && state.operationalCertificateRequest.length) {
            setState(prevState => ({...prevState, selectedFileKey: "operationalCertificateRequest", isModelOpen: true}));
        }
        if (OpFileRef && OpFileRef.current && !state.operationalCertificateRequest) {
            OpFileRef.current.value = "";
        }
    }, [state.operationalCertificateRequest]);

    useEffect(() => {
        dispatch(GetExternalHubURILink());
        setState(prevState => ({
            ...prevState,
            hubMode: isEdit && apiData ? Number(apiData.mode) : Number(NodeType),
            hubURL: isEdit && apiData ? apiData.endPointUrl : EndPoint ? EndPoint : "",
        }))
    },[])

    useEffect(() => {
        if(externalHubUri.length && externalHubUri !== null && externalHubUri !== undefined){
            let networkName = isEdit && apiData ? apiData.networkName : Name;
            let hubURL = externalHubUri+'/'+networkName;
            setState(prevState => ({
                ...prevState,
                hubURL: hubURL
            }))
            if(isLinkModeChange){
                setState(prevState => ({
                    ...prevState,
                    useHubAs: (prevState.useHubAs === "Primary Hub" || prevState.useHubAs === "") ? "Primary Hub" : "Failover Hub",
                }))
            }
        }
    },[state.hubMode]);

    useEffect(() => {
        if(state.useHubAs !== "" && state.hubMode !== 0){
            setState(prevState => ({
                ...prevState,
                primaryHubURI: state.useHubAs === "Primary Hub" ? state.hubURL.replace(state.hubURL.split(":")[1],"//localhost") : (prevState.primaryHubURI !== state.hubURL.replace(state.hubURL.split(":")[1],"//localhost")) ? prevState.primaryHubURI : "",
                failoverHubURI: state.useHubAs === "Failover Hub" ? state.hubURL.replace(state.hubURL.split(":")[1],"//localhost") : (prevState.failoverHubURI !== state.hubURL.replace(state.hubURL.split(":")[1],"//localhost")) ? prevState.failoverHubURI : "",
                primaryURIClassname: "black",
                failoverURIClassname: "black",
            }))
            formError["primaryHubURI"] = "";
            formError["failoverHubURI"] = "";
        }
    },[state.useHubAs, state.hubURL]);

    useEffect(() => {
        if(validTestConURL){
            getTestConnectionLink(formData, getTestConnectionCallBack);
            setValidTestConURL(false);
        }
    },[validTestConURL])

    useEffect(() => {
        if(data !== null && data !== undefined && !isEdit && data.hubMode === "1"){
            if(data.hubMode === NodeType){
                UpdateExistingCertificateStates(data.rootCertificate, data.issuerCertValidityYear, data.rootCertificateValidity, data.operationalCertificate, data.oprCertValidityYear, data.operationalCertificateValidity);
                setState(prevState => ({
                    ...prevState,
                    "useHubAs": EndPoint ? data.primaryHubURI && (EndPoint === data.primaryHubURI.replace(data.primaryHubURI.split(":")[1], EndPoint.split(":")[1]) + '/' + Name) ? "Primary Hub" : data.failoverHubURI && (EndPoint === data.failoverHubURI.replace(data.failoverHubURI.split(":")[1], EndPoint.split(":")[1]) + '/' + Name) ? "Failover Hub" : "" : "",
                    "primaryHubURI":(data.primaryHubURI &&  EndPoint === (data.primaryHubURI.replace(data.primaryHubURI.split(":")[1], EndPoint.split(":")[1]) + '/' + Name)) ? data.primaryHubURI + '/' + Name : data.primaryHubURI,
                    "failoverHubURI": (data.failoverHubURI && EndPoint === (data.failoverHubURI.replace(data.failoverHubURI.split(":")[1], EndPoint.split(":")[1]) + '/' + Name)) ? data.failoverHubURI + '/' + Name : data.failoverHubURI,
                    "tlsVersion": data.tlsVersion ? data.tlsVersion.split(',').length === 2 ? { "min": data.tlsVersion.split(',')[0], "max": data.tlsVersion.split(',')[1] } : { "min": data.tlsVersion.split(',')[0], "max": data.tlsVersion.split(',')[0] } : { "min": "Tls12", "max": "Tls13" },
                    "reconnectTime": data.connectionTimeOut,
                }))
            }
        }
    },[data])

    useEffect(() => {
        let updatedFormError = {...formError}
        delete updatedFormError.primaryHubURI;
        delete updatedFormError.failoverHubURI;
        setFormError(updatedFormError);
        setState(prevState => ({
            ...prevState,
            primaryHubURI: (state.useHubAs !== "" && state.hubMode !== 0 && state.useHubAs === "Primary Hub") ? state.hubURL.replace(state.hubURL.split(":")[1],"//localhost") : (prevState.primaryHubURI !== state.hubURL.replace(state.hubURL.split(":")[1],"//localhost")) ? prevState.primaryHubURI : "",
            failoverHubURI: (state.useHubAs !== "" && state.hubMode !== 0 && state.useHubAs === "Failover Hub") ? state.hubURL.replace(state.hubURL.split(":")[1],"//localhost") : (prevState.failoverHubURI !== state.hubURL.replace(state.hubURL.split(":")[1],"//localhost")) ? prevState.failoverHubURI : "",
            primaryURIClassname: 'black',
            failoverURIClassname: 'black',
        }))
    },[isLinkModeChange])

    const onClickImportBtn = (e, CertificateType) => {
        e.preventDefault();
        setState(prevState => ({...prevState, selectedFileKey: CertificateType, isModelOpen: true}));
    }

    const onClickImport = () => {
        if (((state.selectedFileKey === "issuerCertFile" && hubIssuCertName !== "") 
            || (state.selectedFileKey === "operationalCertificateRequest" && hubOperationCertName !== ""))) {
            uploadCertificateFile(true);
        } else {
            uploadCertificateFile();
        }
    }

    const onClickYes = () => {
        submitForm(submitCallback);
        setState(prevState => ({...prevState, isModelOpen: false}));
    }

    const submitCallback = (status) => {
        if (status === "success") {
            setState(prevState => ({...prevState, isFormError: false, editMode: false}));
            setFormError({});
            refetch();
            getCertificateDetails();
        }
    }

    const fileUploadCallback = (status, error) => {
        if (status === "success") {
            onToggleModel();
        }
    }

    const uploadCertificateFile = (isOverwrite) => {
        if (state.selectedFileKey === "issuerCertFile") {
            if (state.issuerCertFile && state.issuerCertFile.length) {
                if (isOverwrite) {
                    setState((prevState) => ({...prevState, showOverWriteWarning: true}));
                } else {
                    setState((prevState) => ({...prevState, showOverWriteWarning: false}));
                    const payload = new FormData();
                    payload.append("file", state.issuerCertFile[0]);
                    submitForm(payload, fileUploadCallback, state.selectedFileKey, state.hubMode, state.networkID);
                }
            } else {
                let updatedError = {...formError};
                updatedError["issuerCertFile"] = "No certificate file selected";
                setFormError(updatedError);
            }
        } else {
            if (state.operationalCertificateRequest && state.operationalCertificateRequest.length) {
                if (isOverwrite) {
                    setState((prevState) => ({...prevState, showOverWriteWarning: true}));
                } else {
                    setState((prevState) => ({...prevState, showOverWriteWarning: false}));
                    const payload = new FormData();
                    payload.append("file", state.operationalCertificateRequest[0]);
                    submitForm(payload, fileUploadCallback, state.selectedFileKey, state.hubMode, state.networkID);
                }
            } else {
                let updatedError = {...formError};
                updatedError["operationalCertificateRequest"] = "No certificate file selected";
                setFormError(updatedError);
            }
        }
    }

    const onToggleModel = () => {
        setState(prevState => ({
            ...prevState,
            isModelOpen: !prevState.isModelOpen,
            selectedCertificate: prevState.isModelOpen ? null : prevState.selectedCertificate,
            selectedFileKey: null,
            operationalCertificateRequest: "",
            issuerCertFile: ""
        }));
        let updatedFormError = {...formError}
        delete updatedFormError.operationalCertificateRequest;
        delete updatedFormError.issuerCertFile;
        setFormError(updatedFormError);
        setCancelClicked(false);
    }

    const showWarningPopup = () => {
        return (
            <ModelBodyDiv>
                <HeaderTitle id="header-title">
                    <div onClick={onToggleModel}><MdClose /></div>
                    <label>{getLabel("Alert") ? getLabel("Alert") : "Alert"}</label>
                </HeaderTitle>
                <div id="alert-content">
                    {getLabel("AlertMessageOnApply") ? getLabel("AlertMessageOnApply") : "Applying these changes would impact communication with buildings. Are you sure you want to apply these changes ?"}
                </div>
                <FooterButtons id="model-footer-section">
                    <EditActions>
                        <EditNodeButton  id="cancel_button" variant="contained" onClick={onToggleModel}>{getLabel("No") ? getLabel("No") : "No"}</EditNodeButton>
                        <EditNodeButton primary className="btn-black" id="apply_button" variant="contained" onClick={onClickYes}>{getLabel("Yes") ? getLabel("Yes") : "Yes"}</EditNodeButton>
                    </EditActions>
                </FooterButtons>      
            </ModelBodyDiv>
        );
    }

    const showCertUploadModel = () => {
        return (
            <ModelBodyDiv>
                <HeaderTitle id="header-title">
                   <div style={{display : "flex"}}>
                      <label style={{marginRight: 'auto'}}>{getLabel("Import") ? getLabel("Import") : "Import"} {state.selectedFileKey === "issuerCertFile" ? "Issuer Certificate" : "Operational Certificate"}</label>
                      <div onClick={onToggleModel}><MdClose /></div>  
                   </div>
                </HeaderTitle>
                <div id="alert-content">Selected {state.selectedFileKey === "issuerCertFile" ? "Issuer Certificate" : "Operational Certificate"} file to import</div>
                {
                    state.selectedFileKey === "issuerCertFile" ? <FormComponents
                    {...fileNodeCompConfig[0]}
                    compType="file"
                    onChange={onChangeFields}
                    /> : <FormComponents
                    {...fileNodeCompConfig[1]}
                    compType="file"
                    onChange={onChangeFields}
                   />
                }
                <FooterButtons id="model-footer-section">
                    <EditActions>
                        <EditNodeButton  id="cancel_button" variant="contained" onClick={onToggleModel}>{getLabel("Cancel") ? getLabel("Cancel") : "Cancel"}</EditNodeButton>
                        <EditNodeButton 
                            primary 
                            className="btn-black" 
                            id="apply_button" 
                            variant="contained" 
                            disabled={ state.issuerCertFile.length === 0 &&
                                       state.operationalCertificateRequest.length === 0 
                                       ? true: false} 
                            onClick={onClickImport}>
                                {getLabel("Import") ? getLabel("Import") : "Import"}
                        </EditNodeButton>
                    </EditActions>
                </FooterButtons>
            </ModelBodyDiv>
        );
    }

    const onHubValidationModal = () =>{
        return(
            <ModelBodyDiv>
                <HeaderTitle id="header-title">
                    <div style={{display: "flex"}}>
                        <label style={{marginRight: "auto"}}>BACnet Configuration Validation</label>
                    </div>
                </HeaderTitle>
                <div id="alert-content">
                    <center>The following errors must be fixed before the BACnet Configuration can be saved.</center>
                    The Hub for BACnet Secure Connect Link must be configured as either the Primary Hub or Failover Hub.
                </div>
                <FooterButtons id="model-footer-section">
                    <EditActions>
                        <EditNodeButton  primary 
                            className="btn-black" 
                            id="apply_button" 
                            variant="contained"
                            onClick={onToggleHubValidateModel}>OK</EditNodeButton>
                    </EditActions>
                </FooterButtons>
            </ModelBodyDiv>
        )
    }

    const inValidHubURI = (value) => {
        var regexp = /^((w)?(ws)?(wss)?(wss:)?(wss:\/)?(wss:\/\/)?(wss:\/\/.*)?)$/;
        if(!value.match(regexp)){
            return true;
        }else{
            return false;
        }
    }

    const onChangeFields = useCallback((id, value)=>{
        let updatedErrorValue = {...formError};
        //  Empty check for input fields and ignore failover field

        if (fileInputFields.includes(id) && value && value.length) {
            updatedErrorValue[id] = "";
            const fileName = value[0].name.split(".");
            if (fileName[fileName.length - 1] !== "pem" && fileName[fileName.length - 1] !== "PEM") {
                updatedErrorValue[id] = getFormErrorLabel("InvalidFile");
            }
        }

        if(id === "hubMode"){
            if(value === 1)
            {
             let IsHubExists = ValidateHub();
             if(IsHubExists){                
                setShowModeChangeValidationModal(true);                
              }
             else{
             setState(prevState => ({...prevState, hubMode: value}));
             setIsLinkModeChange(value === 1);
              }
            }
            else{
                setState(prevState => ({...prevState, hubMode: value}));
                setIsLinkModeChange(value === 1);
              }
        }

        if (id === "reconnectTime") {
            setState(prevState => ({ ...prevState, reconnectTimeClassname: "black", reconnectTime: value }));
            if (!value || value < 5 || value > 300) {
                setState(prevState => ({ ...prevState, reconnectTimeClassname: "red" }));
                updatedErrorValue[id] = (value && (value < 5 || value > 300)) ? getFormErrorLabel("ConnectionTimeoutDefaultValue") : getFormErrorLabel("ConnectionTimeoutDefaultValue");
            }else {
                updatedErrorValue[id] = "";
            }
        }

        if(id === "tlsVersion"){
            setState(prevState => ({...prevState, tlsVersionClassname: "black", [id]: value}));
            if(value && value.min > value.max){
                setState(prevState => ({...prevState, tlsVersionClassname: "red"}));
                updatedErrorValue[id] = getFormErrorLabel("TlsVersionNumberRange");
            }else{
                updatedErrorValue[id] = "";
            }
        }

        if(id === "primaryHubURI"){ 
            setState(prevState=>({...prevState,primaryURIClassname:"black"}))
            if (!value) {
                setState(prevState=>({...prevState,primaryURIClassname:"red"}))
                updatedErrorValue[id] = getFormErrorLabel("EmptyprimaryHubURI");
            }else if(inValidHubURI(value)){
              setState(prevState => ({...prevState,primaryURIClassname: "red"}))
              updatedErrorValue[id] = getFormErrorLabel("InvalidPrimaryHubURI");  
            }else if(value && value.toLowerCase() === state["hubURL"].toLowerCase() && state["hubMode"] !== 0){
                setState(prevState => ({...prevState, primaryURIClassname: "red"}));
                updatedErrorValue["primaryHubURI"] = getFormErrorLabel("UniqueHubURL");
            }else{
                setState(prevState => ({...prevState,primaryURIClassname: "black",[id]: value}));
                updatedErrorValue[id] = "";
            }
        }
        
        if(id === "failoverHubURI"){
            setState(prevState=>({...prevState,failoverURIClassname:"black"}))
            if(inValidHubURI(value)){
                setState(prevState => ({...prevState, failoverURIClassname: "red", [id]: value}));
                updatedErrorValue[id] = getFormErrorLabel("InvalidFailoverHubURI");
            }else if(value && value.toLowerCase() === state["hubURL"].toLowerCase() && state["hubMode"] !== 0){
                setState(prevState => ({...prevState, failoverURIClassname: "red", [id]: value}));
                updatedErrorValue["failoverHubURI"] = getFormErrorLabel("UniqueHubURL");
            }else{
                setState(prevState => ({...prevState, failoverURIClassname: "black", [id]: value}));
                updatedErrorValue[id] = "";
            }
        }
         else {
            if(id !=="hubMode")
            {
             setState(prevState => ({
              ...prevState,
               [id]: value,
          }));
        }
        }
         
        
        if((isEmpty(updatedErrorValue) && state.isFormError)) {
            setState(prevState => ({ ...prevState, isFormError: false }));
        }
        setFormError(updatedErrorValue);
    }, [formError]);

    const getFileSelectionButtonComp = (idValue) => {    
        const isEmptyFile = !state[idValue] || state[idValue].length === 0; 
        const fileErrorMessage = isEmptyFile ? "(no certificate imported)" : formError[idValue];   
        return (  
            <StyledWrapper style={{position: 'relative'}}> 
                <MultiTagWrapper style={{width:"260px", whiteSpace:"normal", wordBreak:"break-all"}}> 
                    {
                        idValue === "issuerCertFile" && hubIssuCertName ? <div style={{fontSize:"13px", marginTop:"2px", position: 'relative', marginBottom:"5px"}} id="cert-name">{ hubIssuCertName + IssuerCertExpireDt }</div> : null
                    }
                    {
                        idValue !== "issuerCertFile" && hubOperationCertName ? <div style={{fontSize:"13px",marginTop:"2px", position: 'relative', marginBottom:"5px"}} id="cert-name">{ hubOperationCertName + OperationalCertExpireDt }</div> : null
                    }
                    
                    { fileErrorMessage && !state.selectedFileKey && 
                       ( 
                            <FormErrorSectionDiv 
                                disabled={
                                    (hubIssuCertName.length !== 0 && idValue === "issuerCertFile") ||
                                (hubOperationCertName.length !== 0 && idValue === "operationalCertificateRequest")} > 
                                <p>{fileErrorMessage}</p> 
                            </FormErrorSectionDiv>
                        )
                    }
                </MultiTagWrapper>
                <UploadCertiButton 
                    id={`${idValue}-upload-cert-button`}
                    style={{position: 'absolute', display: (isEdit && apiData.mode === 2) ? 'none' : 'block'}}
                    htmlFor={`input_${idValue}`} 
                    variant="contained" 
                    disabled={(hubIssuCertName.length === 0 && idValue === "operationalCertificateRequest")} 
                    onClick={(event) => onClickImportBtn(event, idValue)}
                    >
                    {idValue === "operationalCertificateRequest" ? "Import Opr Cert..." : "Import Iss Cert..."}
                </UploadCertiButton>

            </StyledWrapper> 
        );
    };

    const getFileSelectionComp = (idValue) => { 
        return ( 
           <StyledWrapper>
               <StyledInput
                    id={`input_${idValue}`} 
                    name={`input_${idValue}`} 
                    type="file" 
                    accept=".pem" 
                    ref={idValue === "issuerCertFile" ? rootFileRef : OpFileRef}
                    onChange={(event) => onChangeFields(idValue, Array.from(event.target.files), event)}
                    style={{display:'none'}}
                    />
            </StyledWrapper> 
        );
    };

    const getTestConnectionCallBack = (status, errorDetails) => {
        setIsLoading(false);
        if(status === 'success'){
            setTestConSuccessModal(true);
        }else{
            setapiError(errorDetails.message);
            setTestConErrorModal(true);
        }
    }

    const onClickTestConnection = (event,idValue) => {
        event.preventDefault();
        let updatedErrorValue = { ...formError };
        setIsTestConnection(prevState => ({
            ...prevState,
            status: true,
            primaryHubURLStatus: idValue === "primaryHubURI" ? true : false
        }));
        if(state[idValue] !== ""){
            setIsLoading(true);
            setValidTestConURL(true);
        }else{
            setState(prevState => ({
                ...prevState,
                primaryURIClassname: idValue === "primaryHubURI" ? "red" : prevState.primaryURIClassname,
                failoverURIClassname: idValue === "failoverHubURI" ? "red" : prevState.failoverURIClassname,
            }))
            updatedErrorValue[idValue] = getFormErrorLabel("EmptyTestConnection");
            setFormError(updatedErrorValue);
        }
    }

   const HubURILink = ( idValue) => {  
    const fileErrorMessage = formError[idValue];
        return (
            <StyledWrapper>
                <MultiTagWrapper>
                   <NoMaxWidthTooltip arrow placement="right" title='Enter URL starting with "wss://".' font-size={14}>
                     <MiniStyledInput
                         id={`input_${idValue}`}
                         type={type ? type : "text"}
                         value={idValue === "primaryHubURI" ? state["primaryHubURI"] : state["failoverHubURI"]}
                         className={idValue === "primaryHubURI" ? state["primaryURIClassname"] : state["failoverURIClassname"]}
                         onChange={(event) => onChangeFields(idValue, event.target.value, event)}
                         disabled={disabled}
                         onKeyDown={onKeyDown ? (event) => onKeyDown(idValue, event.code, event) : type === "number" ? blockInvalidChar : undefined}
                         error={error}
                         autoComplete="off"
                     />
                    </NoMaxWidthTooltip>
                     {fileErrorMessage &&
                        (
                            <FormErrorSectionDiv>
                                <p>{fileErrorMessage}</p>
                            </FormErrorSectionDiv>
                        )
                    }
                </MultiTagWrapper>
                {affixLabel ? <label id="affixLabel">{affixLabel}</label> : null}
                <EditNodeButtonContainer>
                    <UploadButton
                    disabled={disabled}
                    for={`input_${idValue}`}
                    error={error}
                    style={{margin: '0 0 26px 22px'}}  variant="contained" id="button"
                    onClick={(event) => onClickTestConnection(event, idValue)}> &nbsp;{getLabel("TestConnection") ? getLabel("TestConnection") : "Test Connection"}&nbsp; 
                   </UploadButton>
                </EditNodeButtonContainer>
            </StyledWrapper>
        );
    }

    const blockInvalidChar = (e) =>
        ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault();

    const linkModeValue = () => {
        return (
            <div style={{ fontFamily: "Verdana", marginBottom: "15px" }} id="node-type">
             {isEdit ?  getLabel("CreateNode." + apiData.mode) : getLabel("CreateNode." + NodeType)}
            </div>
        )
    }

    const reconnectionTimeout = (idValue) =>{
        const fileErrorMessage = formError[idValue];
        return (
        <StyledWrapper>
            <MultiTagWrapper>
            <NumStyledInput
                id={`input_${idValue}`}
                type={type ? type : "text"}
                value={state["reconnectTime"]}
                className={state.reconnectTimeClassname}
                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                onChange={(event) => onChangeFields(idValue, event.target.value, event)}
                disabled={disabled}
                onKeyDown={onKeyDown ? (event) => onKeyDown(idValue, event.code, event) : type === "number" ? blockInvalidChar : undefined}
                error={error}
                autoComplete="off"
            />
            {fileErrorMessage && (
                <FormErrorSectionDiv>
                <p style={{fontSize : "11px"}}>{fileErrorMessage}</p>
                </FormErrorSectionDiv>
            ) }
            </MultiTagWrapper>
            {affixLabel ? <label id="affixLabel">{affixLabel}</label> : null}
        </StyledWrapper>
        );
    }

    const getHubUrlValue = () => {
        return(
            <div id="huburlvalue" style={{ fontFamily: "Verdana", marginBottom: "15px" }}>
                {state["hubURL"]}
            </div>
        )
    }

    const showHubTextMessage = (value) => {
        return(
            <div style={{ fontFamily: "Verdana", marginBottom: "15px" }}>
                {`(Uses local Hub as ${value})`}  
            </div>
        )
    }

    const fileNodeCompConfig = [
        {
            label: getLabel("IssuerCertificate") ? getLabel("IssuerCertificate") : "Issuer Certificate",
            id: "issuerCertFile",
            compType: () => getFileSelectionComp("issuerCertFile"),
            name: true,
            accept: ".pem",
            value: (state["issuerCertFile"] && state["issuerCertFile"].length) ? state["issuerCertFile"][0].name : "",
            error: state["issuerCertFile"].length ?formError["issuerCertFile"]: "",
        },
        {
            label: getLabel("OperationalCertificate") ? getLabel("OperationalCertificate") : "Operational Certificate",
            id: "operationalCertificateRequest",
            compType: () => getFileSelectionComp("operationalCertificateRequest"),
            value: (state["operationalCertificateRequest"] && state["operationalCertificateRequest"].length) ? state["operationalCertificateRequest"][0].name : "",
            error: state["operationalCertificateRequest"].length ?formError["operationalCertificateRequest"]: "",
            accept: ".pem",
            name: true,
        }
    ];

    const editNodeCompConfig = [  
        {
            label: getLabel("Mode") ? getLabel("Mode") : "Link Mode",
            id: "hubMode",
            ...(isEdit && apiData.mode !== 2) ? { compType: "integerDropdown" } : { compType: () => linkModeValue("hubMode") },
            options: linkNodeOptions,
            name: true,
            value: state["hubMode"],
        },
        {
            label: getLabel("Hub URL") ? getLabel("Hub URL") : "Hub URL",
            id: "huburl",
            name: true,
            compType: () => getHubUrlValue("huburl"),
        },
        {
            label: getLabel("IssuerCertificate") ? getLabel("IssuerCertificate") : "Issuer Certificate",
            id: "issuerCertFile",
            compType: () => getFileSelectionButtonComp("issuerCertFile"),
            name: true,
            accept: ".pem",
            value: (state["issuerCertFile"] && state["issuerCertFile"].length) ? state["issuerCertFile"][0].name : "",
            error: state["issuerCertFile"].length ?formError["issuerCertFile"]: "",
        },
        {
            label: getLabel("OperationalCertificate") ? getLabel("OperationalCertificate") : "Operational Certificate",
            id: "operationalCertificateRequest",
            compType: () => getFileSelectionButtonComp("operationalCertificateRequest"),
            value: (state["operationalCertificateRequest"] && state["operationalCertificateRequest"].length) ? state["operationalCertificateRequest"][0].name : "",
            error: state["operationalCertificateRequest"].length ?formError["operationalCertificateRequest"]: "",
            accept: ".pem",
            name: true,
        },
        {
            label: getLabel("UseHubAs") ? getLabel("UseHubAs") : "Use this Hub As",
            id: "useHubAs",
            name: true,
            type: "radio",
            compType: "doubleRadio",
            radiolabel: ["Primary Hub", "Failover Hub"],
            checked: state["useHubAs"],
        },
        {
            label: getLabel("PrimaryHubURL") ? getLabel("PrimaryHubURL") : "Primary Hub URL*",
            id: "primaryHubURI",
            name: true,
            ...(state["hubMode"] !== 0  && state["useHubAs"] === "Primary Hub") ? {compType: () => showHubTextMessage("primary","primary")} : {compType: () => HubURILink("primaryHubURI")},
            type: "text",
            error: formError["primaryHubURI"] ? formError["primaryHubURI"] : "",
        },
        {
            label: getLabel("FailoverHubURL") ? getLabel("FailoverHubURL") : "Failover Hub URL",
            id: "failoverHubURI",
            ...(state["hubMode"] !== 0 && state["useHubAs"] === "Failover Hub") ? {compType: () => showHubTextMessage("failover","failover")} : {compType: () => HubURILink("failoverHubURI")},
            type: "text",
            name: true,
            error: formError["failoverHubURI"] ? formError["failoverHubURI"] : "",
        },
        {
            label: getLabel("TLSVersion") ? getLabel("TLSVersion") : "TLS Version",
            id: "tlsVersion",
            compType: "doubleDropdown",
            name: true,
            value: state["tlsVersion"],
            options: data && data.tlsOptions ? data.tlsOptions : [],
            error: formError["tlsVersion"] ? formError["tlsVersion"] : "",
        },
        {
            label: getLabel("ConnectionTimout") ? getLabel("ConnectionTimout") : "Connection Timeout (seconds)*",
            id: "reconnectTime",
            compType:() => reconnectionTimeout("reconnectTime"),
            type: "number",
            value: state["reconnectTime"],
        },
    ];

    const rows = [
        { label: "Name" },
        { label: "Conection Status" },
        { label: "Mode" },
        { label: "BUilding Name" },
        { label: "Hub URL" }
    ];

    const onModeChangeValidationModal = () => {
        return <>
            <HeaderTitle id="hub-header-title" className="HubValidation-lbl">
                {                   
                    <span><b>Warning:</b>&nbsp;&nbsp;Selecting this Mode will change all existing BACnet/SC Hub Links to Node+Hub Mode.  Tracer Ensemble Hub Links must all be configured the same.  Proceeding to change to all Hub Links to Node+Hub Mode may break existing BACnet/SC connections.</span>
                }
            </HeaderTitle>
            <FooterButtons id="hub-model-footer-section">
                <EditActions >
                    <Button style={{margin : "25px 0 0 150px", "color":"white"}} id="hub_cancel_button" variant="contained" onClick={onCancelHubValidation}>{getLabel("Cancel") ? getLabel("Cancel") : "Cancel"}</Button>
                    <Button style={{margin : "25px 0 0 15px", "background-color": "#2070cf", "color":"white"}} id="hub_ok_button" variant="contained" onClick={onContinueSave}>{getLabel("OK") ? getLabel("OK") : "OK"}</Button>
                </EditActions>
            </FooterButtons>
        </>
    }

    const onToggleModeChangeValidationModal = () => {
        setShowModeChangeValidationModal(!showModeChangeValidationModal);
    }
  
    const ValidateHub = () => {
        let isHubExists = false;
        if (Array.isArray(networkList) && networkList.length) {
            const lstNetworks = JSON.parse(JSON.stringify(networkList));
            for (let i = 0; i < lstNetworks.length; i++) {
                if (lstNetworks[i] && lstNetworks[i].mode === 2) {
                    isHubExists = true;
                    break;
                }
            }
        }
        return isHubExists;
    }

    const onContinueSave = () => {
        setState(prevState => ({ ...prevState, hubMode: 1  }));
        setIsLinkModeChange(true);

        onToggleModeChangeValidationModal();
    }
               
    const onCancelHubValidation = () => {
        onToggleModeChangeValidationModal();
    }


    const DataTable = () => {
        return (
            data.length ?
                <EditTableContainer>
                    <Table size="small" className={`material-ui-table`}>
                        <TableHead style={{ fonFamily: "Verdana", background: "#467e26", borderRadius: "2px", height: "50px" }}>
                            <TableRow>
                                {rows.map((item) => {
                                    return <TableCell style={{ color: "#ffffff", fontSize: "15px" }}>{item.label}</TableCell>
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody className="material-ui-table-body">

                        </TableBody>
                    </Table>
                </EditTableContainer> 
            : null
        );
    }

    const onToggleOverWriteModel = () => {
        setAPIHookData(prevState => ({...prevState, fileUploadError: ""}));
        setState(prevState => ({
            ...prevState,
            showOverWriteWarning: false
        }));
    }

    const onToggleHubValidateModel = () => {
        setShowHubValidationModal(false);
    }

    const fileUploadErrorModel = () => {  
        return <>
                <HeaderTitle id="header-title" errorTitle>
                    <div onClick={onToggleOverWriteModel}><MdClose /></div>
                    <label><BsFillXOctagonFill />{getLabel("ImportCertificateError") ? getLabel("ImportCertificateError") : "Import Certificate Error"}</label>
                </HeaderTitle>
                <div id="import-file-error">
                {getLabel("ImportCertificateErrorMessage") ? getLabel("ImportCertificateErrorMessage") : "The following error occurred while importing certificate..."}
                </div>
                <div id="import-file-error-message">
                    {fileUploadError}
                </div>
                <FooterButtons id="model-footer-section">
                <EditActions isOverwriteModel>
                    <Button style={{margin : "0px 15px"}} id="cancel_button" variant="contained" onClick={onToggleOverWriteModel}>{getLabel("OK") ? getLabel("OK") : "OK"}</Button>
                </EditActions>
                </FooterButtons>
        </>
    }

    const certificateName = state.selectedFileKey === "issuerCertFile" ? "Issuer Certificate" : "Operational Certificate";

    const overwriteWarningModel = () => {
        return <>
                <HeaderTitle id="header-title">
                    <div style={{display : "flex"}}>
                        <label  style={{marginRight: 'auto'}}>{getLabel("ConfirmImport") ? getLabel("ConfirmImport") : "Confirm Import"} {certificateName}</label>
                        <div onClick={onToggleOverWriteModel}><MdClose /></div>
                    </div>
                </HeaderTitle>
                <div id="alert-content">
                    You are about to import a new {certificateName} This will replace 
                    the current {certificateName} for this link. Do you want to overwrite the existing certificate?
                </div>
                <FooterButtons id="model-footer-section">
                <EditActions isOverwriteModel>
                    <EditNodeButton  id="cancel_button" variant="contained" onClick={onToggleOverWriteModel}>{getLabel("NoCancel") ? getLabel("NoCancel") : "No - Cancel"}</EditNodeButton>
                    <EditNodeButton primary className="btn-black" id="apply_button" variant="contained" onClick={()=>uploadCertificateFile()}>{getLabel("YesOverwrite") ? getLabel("YesOverwrite") : "Yes - Overwrite"}</EditNodeButton>
                </EditActions>
                </FooterButtons>
            </>
    }

    const getModelModelBodyComp = () => {
        if(state.selectedFileKey) {
            return showCertUploadModel();
        }else {
            return showWarningPopup();
        }
    }

    const onCancelWarningModal = () =>{
        return  <>
               <HeaderTitle id="header-title">
                    <div onClick={onClickCancel}><MdClose /></div>
                </HeaderTitle>
                <div id="alert-content">
                  Cancel this Link will permanently remove all link information including URLs and Certificates.
                  The Delete operation is performed immediatly and may not later be canceled!
                  Do you want to proceed?
                </div>
                <FooterButtons id="model-footer-section">
                <EditActions isOverwriteModel>
                    <EditNodeButton  id="cancel_button" variant="contained" onClick={onClickCancel}>{getLabel("NoCancel") ? getLabel("NoCancel") : "No - Cancel"}</EditNodeButton>
                    <EditNodeButton primary className="btn-black" id="apply_button" variant="contained" onClick={OnCancel}>{getLabel("YesOverwrite") ? getLabel("YesOverwrite") : "Yes - Delete"}</EditNodeButton>
                </EditActions>
                </FooterButtons>
             </>     
    }

    const onCancelErrorModal = () => {
        setShowErrorModal(!showErrorModal);
      };

    const onSaveErrorModal = () =>{
        return <>
            <HeaderTitle id="header-title">
                <div onClick={onCancelErrorModal}><MdClose /></div>
                <label><BsFillXOctagonFill /><span>{getLabel("ImportCertificateErrorMessage") ? getLabel("ImportCertificateErrorMessage") : "Something went wrong. Please Try Again..."}</span></label>
            </HeaderTitle>
            <FooterButtons id="model-footer-section">
                <EditActions >
                    <Button style={{margin : "25px 0 0 190px"}} id="cancel_button" variant="contained" onClick={onCancelErrorModal}>{getLabel("OK") ? getLabel("OK") : "OK"}</Button>
                </EditActions>
            </FooterButtons>
        </>
    }

    const onClickCancel = () => {
        setState(prevState => ({
            ...prevState,
        }));
        setCancelClicked(false);
    };

    const toggleModal = () => {
          setCancelClicked(true);
    };

    const SaveEditNodeDetails = async (data, callBackFunction) => {
        setIsLoading(true);
        try {
          const response = !isEdit ? await APIutil.postData(url.post_secure_network_link, data) : await APIutil.postData(url.update_secure_network_link, data);
          if (response && response.status === 200) {
            useAddSecureConnectNetworkPort(isEdit ? data.NetworkID : response.data.networkID, isEdit);
            callBackFunction && callBackFunction("success");
          } else {
            const message =
              response && response.statusText
                ? response.statusText
                : "Something went wrong. Please try refreshing the page.";
            callBackFunction && callBackFunction("error", { message });
          }
        } catch (error) {
          callBackFunction && callBackFunction("error", error);
          throw error;
        }
    }

    const handleSave = () => { 
        setState(prevState=>({...prevState,primaryURIClassname:"black", failoverURIClassname:"black"}));
        if((state["primaryHubURI"] && !inValidHubURI(state["primaryHubURI"])) && 
            (!state["failoverHubURI"] || (state["failoverHubURI"] && !inValidHubURI(state["failoverHubURI"]))) &&
            ((state["useHubAs"] !=="" && state["hubMode"] !== 0) || state["hubMode"] === 0)&& 
            ((state["reconnectTime"] >= 5) && (state["reconnectTime"] <= 300)) && 
            (state["tlsVersion"].min <= state["tlsVersion"].max) && 
            (state["primaryHubURI"].toLowerCase() !== state["failoverHubURI"].toLowerCase()) &&
            (state["hubMode"] === 0 ? true : ((state["hubMode"] !== 0 && state["failoverHubURI"].toLowerCase() !== state["hubURL"].toLowerCase()) || state["useHubAs"] === "Failover Hub") ? true : false) &&
            (state["hubMode"] === 0 ? true : ((state["hubMode"] !== 0 && state["primaryHubURI"].toLowerCase() !== state["hubURL"].toLowerCase()) || state["useHubAs"] === "Primary Hub") ? true : false) 
            )
            {SaveEditNodeDetails(formData, (status, error) => {
                if (status === "success") {
                    setIsLoading(false);
                    getNetworkList();
                    OnCancel();
                } else {
                    console.error("Error saving data:", error);
                    setIsLoading(false);
                    setShowErrorModal(true);
                }
            });}
        else {
            let updatedErrorValue = { ...formError };
            if(!state["primaryHubURI"]) {
                updatedErrorValue["primaryHubURI"] = getFormErrorLabel("EmptyprimaryHubURI");
                setState(prevState => ({ ...prevState, primaryURIClassname: "red" }));
            }else if(inValidHubURI(state["primaryHubURI"])){
                updatedErrorValue["primaryHubURI"] = getFormErrorLabel("InvalidPrimaryHubURI");
                setState(prevState => ({ ...prevState, primaryURIClassname: "red" }));
            }else if(state["failoverHubURI"] && inValidHubURI(state["failoverHubURI"])){
                updatedErrorValue["failoverHubURI"] = getFormErrorLabel("InvalidFailoverHubURI");
                setState(prevState => ({...prevState, failoverURIClassname: "red"}));
            }else if(state["primaryHubURI"].toLowerCase() === state["failoverHubURI"].toLowerCase()){
                setState(prevState => ({...prevState, failoverURIClassname: "red"}));
                updatedErrorValue["failoverHubURI"] = getFormErrorLabel("UniqueHubURL");
            }
            if(!state["reconnectTime"]){
                updatedErrorValue["reconnectTime"] = "Connection Timeout is Required";
                setState(prevState => ({ ...prevState, reconnectTimeClassname: "red" }));
            }else if((state["reconnectTime"] < 5 || state["reconnectTime"] > 300)) {
                updatedErrorValue["reconnectTime"] = getFormErrorLabel("EmptyConnectionTimeout");
                setState(prevState => ({ ...prevState, reconnectTimeClassname: "red" }));
            }
            if(state["hubMode"] !== 0){
                if(state["primaryHubURI"].toLowerCase() === state["hubURL"].toLowerCase() && state["useHubAs"] !== "Primary Hub")
                {
                    setState(prevState => ({...prevState, primaryURIClassname: "red"}));
                    updatedErrorValue["primaryHubURI"] = getFormErrorLabel("UniqueHubURL");
                }else if(state["failoverHubURI"].toLowerCase() === state["hubURL"].toLowerCase() &&state["useHubAs"] !== "Failover Hub")
                {
                    setState(prevState => ({...prevState, failoverURIClassname: "red"}));
                    updatedErrorValue["failoverHubURI"] = getFormErrorLabel("UniqueHubURL");
                }else if(state["useHubAs"] === ""){
                    updatedErrorValue["primaryHubURI"] = getFormErrorLabel("HubValidation");
                    setState(prevState => ({...prevState, primaryURIClassname: "red"}));
                    setShowHubValidationModal(true);
                }
            }
            setFormError(updatedErrorValue);
        }
    };

    const handleCheckboxChange = (event) => {
        setIsEnabled(event.target.checked);
    };

    const onClickCancelCSRbtn = () =>{
        setState(prevState => ({
            ...prevState,
        }));
        setCsrErrorModel(false);
    }

    const getGenerateCSRModel = () =>{
        return <>
            <HeaderTitle id="header-title">
                    <div style={{display : "flex"}}>
                        <label  style={{marginRight: 'auto'}}>WARNING: Generate New CSR </label>
                        <div onClick={onClickCancelCSRbtn}><MdClose /></div>
                    </div>
                </HeaderTitle>
                <div id="alert-content">
                    Generating a <b>new</b> CSR will invalidate the previous CSR!<br/>
                   <span>Are you sure you want to generate a new CSR?</span> 
                </div>
                <FooterButtons id="model-footer-section">
                <EditActions isOverwriteModel>
                    <EditNodeButton primary className="btn-black" id="apply_button" variant="contained" onClick={() => {downloadCSRCertificate("NewRequest.csr"); getGenerateCSRSuccessModel()} }>{getLabel("YesOverwrite") ? getLabel("YesOverwrite") : "Yes - Generate CSR"}</EditNodeButton>
                    <EditNodeButton  id="cancel_button" variant="contained" onClick={onClickCancelCSRbtn}>{getLabel("NoCancel") ? getLabel("NoCancel") : "No - Cancel"}</EditNodeButton>
                </EditActions>
                </FooterButtons>
        </>
    }

    const handleCSRSuccessModel = () =>{
        return <>
            <HeaderTitle id="header-title">
                <div style={{display : "flex"}}>
                    <label  style={{marginRight: 'auto'}}>CSR Generated Successfully </label>
                    <div onClick={onCancelCSRSuccessModel}><MdClose /></div>
                </div>
            </HeaderTitle>
            <div id="Success-alert-content">
               CSR was generated successfully, check your "Downloads" folder for the CSR.
            </div>
            <FooterButtons id="model-footer-section">
            <EditActions >
                <EditNodeButton primary className="btn-black" id="apply_button" variant="contained" onClick={onCancelCSRSuccessModel}>{getLabel("OK") ? getLabel("OK") : "OK"}</EditNodeButton>
            </EditActions>
            </FooterButtons>
    </>
    }

    const onCancelCSRSuccessModel = () =>{
        setState(prevState => ({
            ...prevState,
        }));
        setCsrSuccessModel(false);
    }

    const getGenerateCSRSuccessModel = () =>{
        setCsrSuccessModel(true);
        onClickCancelCSRbtn();
    }

    const onClickGenarateCSRBtn = () =>{
        setCsrErrorModel(true);
    }

    const onCloseTestConModal = () =>{
        setState(prevState => ({...prevState}));
        setTestConSuccessModal(false);
        setTestConErrorModal(false);
        setapiError('');
    };

    const handleTestConSuccessModal = () =>{
        return<>
            <HeaderTitle id="header-title">
                <div>
                    <label style={{marginRight: 'auto'}}>Test Connection</label>
                </div>
            </HeaderTitle>
            <div id="body-content">
                <label>Test Connection for <b>{isTestConnection.primaryHubURLStatus ? state.primaryHubURI : state.failoverHubURI}</b> was successful</label>
            </div>
            <FooterButtons id="model-footer-section">
                <EditActions >
                    <EditNodeButton primary className="btn-black" id="apply_button" variant="contained" onClick={onCloseTestConModal}>{getLabel("OK") ? getLabel("OK") : "OK"}</EditNodeButton>
                </EditActions>
            </FooterButtons>
        </>
    }

    const handleTestConErrorModal = () => {
        return<>
        <HeaderTitle id="header-title">
            <div>
                <label style={{marginRight: 'auto'}}>Test Connection Error</label>
            </div>
        </HeaderTitle>
        <div id="body-content">
            <label>Test Connection for <b>{isTestConnection.primaryHubURLStatus ? state.primaryHubURI : state.failoverHubURI}</b> failed with the following error...</label><br/>
            <label><b>{apiError}</b></label>
        </div>
        <FooterButtons id="model-footer-section">
            <EditActions >
                <EditNodeButton primary className="btn-black" id="apply_button" variant="contained" onClick={onCloseTestConModal}>{getLabel("OK") ? getLabel("OK") : "OK"}</EditNodeButton>
            </EditActions>
        </FooterButtons>
    </>
    }

    const FilterOptions = state["hubMode"] === 0 ? ["huburl","useHubAs"] : [];
    return (        
           <div>
            <EditTableContainer>
                <Header className='workordermainheaderlbl' id="network-headerlabel">
                    {getLabel("HeaderTitle") ? getLabel("HeaderTitle") : "Manage Secure Connect BACnet Network"}
                    &nbsp; - <b style={{ fontFamily: "Verdana" }}>{isEdit ? apiData.networkName ? apiData.networkName : "" : Name }</b>
                </Header>
                <Table size="small" aria-label="simple table" id="view-hub-params-table" className={`material-ui-table`}>
                    <TableBody className="material-ui-table-body">
                    <TableRow >
                            <TableCell >
                                <div>
                                    <span style={{ accentColor: "gainsboro", verticalAlign: "middle" }}><input id="enabled-checkbox" type="checkbox" checked={IsEnabled} onChange={handleCheckboxChange} />&nbsp;&nbsp;</span>
                                    <label id="enabled-label" style={{ fontWeight: "bold", color: "#333333", marginBottom: 0, fontSize: "medium" }}>{getLabel("Enabled") ? getLabel("Enabled") : "Enabled"}</label>
                                </div>
                            </TableCell>
                            {
                                isEdit && apiData.mode !== 2 ? 
                                    <EditNodeButtonContainer >
                                        <UploadButton id="upload-new-csr-button" style={{margin: "10px 0 0 306px", width: "157px", padding: "7px 0 0 15px" }} onClick={onClickGenarateCSRBtn}
                                        >  {getLabel("Create.GenerateNewCSR") ? getLabel("Create.GenerateNewCSR") : "Generate New CSR"} 
                                        </UploadButton>
                                    </EditNodeButtonContainer> :
                                null
                            }
                        </TableRow>
                       
                        {
                            editNodeCompConfig.map(item => item).filter(x => !FilterOptions.includes(x.id)).map((item) => {
                                return <TableRow {...TableRowProps}>
                                    <TableCell>{item.label}{item.name ?
                                        <NoMaxWidthTooltip arrow placement={(item.id === "issuerCertFile" || item.id === "operationalCertificateRequest") ? "top-start" : "right"}
                                            title={
											item.id === "hubMode" ? "Select a mode based on the function of the device on the BACnet/SC network." :
                                                item.id === "primaryHubURI" ? "The Primary Hub URL points to the Primary Hub Device." :
                                                    item.id === "tlsVersion" ? "This is the acceptable range of TLS Version. TLS Version default to the highest version when several are available." :
                                                        item.id === "failoverHubURI" ? "The Failover Hub URL points to the Failovre hub Device." :
                                                            item.id === "operationalCertificateRequest" ? 'The Operational Certificate name and expiration will appear here after uploading the Operational Certificate. Operational Certificates can be uploaded using the "Import Operational Cert" action.' :
                                                                item.id === "issuerCertFile" ? 'Issuer Certificate name and expiration will appear here after uploading the Issuer Certificate. Issuer Certificates can be uploaded using the "Import Issuer Certificate" action.' :                                                                    
                                                                    item.id === "huburl" ? "Hub URL help goes here..." :
                                                                        item.id === "useHubAs" ? "Use Hub as help goes here..." : null}>
                                            <IconButton style={{ float: 'right', margin: '-5px -39px 11px -6px', backgroundColor: 'white', color: "currentColor", fontSize: "larger" }}>
                                                <BsQuestionCircleFill />
                                            </IconButton>
                                        </NoMaxWidthTooltip>
                                        : ''}
                                    </TableCell>
                                    <TableCell {...TableCellClass}>
                                        <FormComponents
                                            {...item}
                                            onChange={onChangeFields}
                                        />
                                    </TableCell>
                                </TableRow>
                            })
                        }
                    </TableBody>
                </Table>
                { (isEdit) ? cancelClicked && OnCancel() : cancelClicked &&(<WarningModal
                    isOpen={!state.isModelOpen}
                    >
                     {onCancelWarningModal()}
                    </WarningModal> )
                }

                {showErrorModal && (<ErrorModal
                    isOpen={!state.isModelOpen}
                    >
                     {onSaveErrorModal()} 
                    </ErrorModal>)
                }               
                
                

                {csrErrorModel && (<GenerateCSRModal
                    isOpen={!state.isModelOpen}
                    >
                      {getGenerateCSRModel()}
                    </GenerateCSRModal>)
                }

                {csrSuccessmodel && (<GenerateCSRModal
                    isOpen={!state.isModelOpen}
                    >
                      {handleCSRSuccessModel()}
                    </GenerateCSRModal>)
                }

                {testConSuccessModal && (<TestConnectionModal
                    isOpen={!state.isModelOpen}
                    >
                        {handleTestConSuccessModal()}
                    </TestConnectionModal>)
                }

                {testConErrorModal && <TestConnectionModal
                    isOpen={!state.isModelOpen}
                    >
                        {handleTestConErrorModal()}
                    </TestConnectionModal>
                }

                <HubParamModal
                    isOpen={state.isModelOpen}
                    toggle={onToggleModel}
                    id="view-hub-parameters-model"
                    isAlertModel={state.selectedCertificate}
                    >
                    {
                        getModelModelBodyComp()
                    }
                </HubParamModal> 

                <HubParamModal
                    isOpen={state.showOverWriteWarning || fileUploadError}
                    toggle={onToggleOverWriteModel}
                    id="certificate-warning-model"
                    isOverwriteModel
                    fileUploadError={fileUploadError}
                    >
                    <ModelBodyDiv>
                        {
                        fileUploadError ? fileUploadErrorModel() : overwriteWarningModel()
                        }
                    </ModelBodyDiv>
                </HubParamModal>

                <HubParamModal
                    isOpen={showHubValidationModal}
                    toggle={onToggleHubValidateModel}
                    id="hub-validation-modal"
                    >
                    {
                        onHubValidationModal()
                    }
                </HubParamModal>   

                {
                    showModeChangeValidationModal && (
                        <ErrorModal
                    isOpen={!state.showModeChangeValidationModal}
                    >
                     {onModeChangeValidationModal()} 
                    </ErrorModal>)                   
                }             

                {loading ? <SpinnerContainer>
                                <Spinner />
                           </SpinnerContainer> 
                        : null
                }

                {fileUploading ? <FileUploadSpinner>
                    <Spinner loadingContent={getLabel("ImportingCertificate") ? getLabel("ImportingCertificate") : "Importing Certificate..."}/>
                </FileUploadSpinner> : null }
            </EditTableContainer>
            <footer>{DataTable()}</footer>
            <div style={{display : "flex", marginLeft: "35px"}}>
                <EditNodeButton variant="contained" id="button" onClick={toggleModal}>
                    {getLabel("Cancel") ? getLabel("Cancel") : "Cancel"}
                </EditNodeButton>
                <EditNodeButton id="save-button" primary className="btn-black" onClick={handleSave}>
                    {getLabel("Save") ? getLabel("Save") : "Save"}
                </EditNodeButton>
            </div>
        </div>
    );
};

export default EditNodeDetails;